/*
 * @Author: your name
 * @Date: 2020-12-02 12:25:00
 * @LastEditTime: 2021-01-13 15:39:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \meb.work.admin\src\plus\api\log.js
 */
import http from '../http';

const log = {
    /**
     * 用户登录日志
     */
    getLoginLogList(filter) {
        return http.get(`/auth_resource/getLoginLogList`, {params: filter});
    },
    /**
     * 获取用户信息列表
     */
    getUserInfoList(model) {
        return http.post(`/auth_resource/userInfo/getUserInfoList`, model);
    },
    logOut(){
        return http.post('/auth_resource/logout')
    }
    
}
export default log;